import http from '@/requests/http'

class Company {
  static findAll (params) {
    return http.post('management/company', params)
  }
  static store (params) {
    return http.post('management/company/store', params)
  }
  static view (params) {
    return http.post('management/company/view', params)
  }
  static worktimeView () {
    return http.post('company/worktime/view')
  }
  static worktimeUpdate (params) {
    return http.post('company/worktime/update', params)
  }
  static update (params) {
    return http.post('management/company/update', params)
  }
  static destroy (params) {
    return http.post('management/company/destroy', params)
  }
  static destroyData (params) {
    return http.post('management/company/data/destroy', params)
  }
  static async recSystemCredential () {
    return http.post('management/company/rec/credential')
  }
  static loginViaApiKey (apiKey) {
    return http.post('company/login', {apiKey})
  }
}

export default Company
